import {isServer as isServerTanstack} from "@tanstack/react-query";
export const isServer = isServerTanstack;